class NavbarCustom extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.isVisible = false;
    this.isHoveringNavbar = false;
    this.showThreshold = window.innerHeight * 0.05;
    this.hideTimeout = null;
    this.hideDelay = 1000;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.setupMenuLinks();
    this.setupCursorDetection();
    this.setupNavbarHoverDetection();
    this.setupResize();
  }

  setupMenuLinks() {
    const links = this.querySelectorAll('.m-navbar-custom__link');
    const currentPath = window.location.pathname;

    links.forEach((link) => {
      link.addEventListener('click', () => {
        links.forEach((l) => l.classList.remove('is-active'));
        link.classList.add('is-active');
      });

      if (link.getAttribute('href') === currentPath) {
        link.classList.add('is-active');
      }
    });
  }

  scheduleHide() {
    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => this.hideNavbar(), this.hideDelay);
  }

  setupCursorDetection() {
    document.addEventListener('mousemove', (e) => {
      if (e.clientY <= this.showThreshold || this.isHoveringNavbar) {
        clearTimeout(this.hideTimeout);
        this.showNavbar();
      } else if (this.isVisible) {
        this.scheduleHide();
      }
    });

    document.addEventListener('mouseleave', () => this.scheduleHide());
  }

  setupNavbarHoverDetection() {
    this.addEventListener('mouseenter', () => {
      this.isHoveringNavbar = true;
      clearTimeout(this.hideTimeout);
    });

    this.addEventListener('mouseleave', () => {
      this.isHoveringNavbar = false;
      if (this.isVisible) this.scheduleHide();
    });
  }

  setupResize() {
    window.addEventListener('resize', () => {
      this.showThreshold = window.innerHeight * 0.05;
    });
  }

  showNavbar() {
    if (this.isVisible) return;
    this.isVisible = true;
    this.classList.add('is-visible');
  }

  hideNavbar() {
    clearTimeout(this.hideTimeout);
    if (this.isVisible) {
      this.isVisible = false;
      this.classList.remove('is-visible');
    }
  }
}

if (!customElements.get('navbar-custom')) {
  customElements.define('navbar-custom', NavbarCustom);
}
